export default () => (
  <svg
    width="12"
    height="21"
    viewBox="0 0 12 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99942 20.5001C7.87169 20.5001 9.38947 19.893 9.38947 19.1441C9.38947 18.3952 7.87169 17.7881 5.99942 17.7881C4.12715 17.7881 2.60938 18.3952 2.60938 19.1441C2.60938 19.893 4.12715 20.5001 5.99942 20.5001Z"
      fill="currentColor"
    />
    <path
      d="M5.99904 0.5C4.51833 0.5 3.09826 1.08821 2.05125 2.13523C1.00423 3.18225 0.416016 4.60231 0.416016 6.08302C0.416016 9.97723 3.84828 13.864 5.99904 15.898C8.14979 13.864 11.5821 9.97723 11.5821 6.08302C11.5821 5.34985 11.4377 4.62386 11.1571 3.94649C10.8765 3.26913 10.4653 2.65366 9.94683 2.13523C9.4284 1.6168 8.81293 1.20556 8.13557 0.924982C7.4582 0.644409 6.73221 0.5 5.99904 0.5ZM5.99904 9.07818C5.40602 9.08113 4.82548 8.90798 4.33097 8.58067C3.83647 8.25335 3.45025 7.78661 3.22127 7.23958C2.99228 6.69256 2.93084 6.08987 3.04472 5.50788C3.1586 4.9259 3.44268 4.39082 3.86096 3.97045C4.27924 3.55007 4.8129 3.26333 5.39431 3.14655C5.97571 3.02977 6.5787 3.0882 7.12687 3.31446C7.67503 3.54071 8.14369 3.92459 8.47347 4.41746C8.80325 4.91033 8.97929 5.49 8.9793 6.08302C8.97996 6.87501 8.66666 7.63497 8.10804 8.19639C7.54941 8.75781 6.79102 9.0749 5.99904 9.07818Z"
      fill="currentColor"
    />
  </svg>
);
